import { CellProps } from 'react-table'
import { LogAtendimentoView } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { formatDateTime } from '_metronic/helpers'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from 'app/components'

export const LogsConsultaIdColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<LogAtendimentoView>> => [
  sortableColumn<LogAtendimentoView>({
    id: 'data',
    cellWidth: '170px',
    useQueryRequest,
    fields: [{ field: 'data', label: t('cols.data') }],
    Cell: ({ row }: CellProps<LogAtendimentoView>) => (
      <StackedCell
        tabular
        primary={formatDateTime(row.original.data, row.original.dataFormatada)}
      />
    ),
  }),
  // Ação com a descrição como apoio (só a descrição ordena).
  sortableColumn<LogAtendimentoView>({
    id: 'descricao',
    useQueryRequest,
    fields: [
      { field: 'nome', label: 'Ação', sortable: false },
      { field: 'descricao', label: 'Descrição' },
    ],
    Cell: ({ row }: CellProps<LogAtendimentoView>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.descricao} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.responsavel')}</PlainHeader>,
    id: 'usuario.nome',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<LogAtendimentoView>) => (
      <StackedCell primary={row.original.usuario?.nome} />
    ),
  },
  // Texto livre, às vezes longo (ex.: por que a lotação do solicitante não foi determinada):
  // fica por último com a maior largura e quebra linha em vez de truncar como o StackedCell.
  {
    Header: () => <PlainHeader>{t('cols.observacao')}</PlainHeader>,
    id: 'observacao',
    cellWidth: '40%',
    Cell: ({ row }: CellProps<LogAtendimentoView>) => (
      <span className='text-gray-800 text-break'>{row.original.observacao || '—'}</span>
    ),
  },
]
